import {
  OrderingPathway,
  PathologyFaxAction,
  LdtOrderDetailFieldsFragment,
} from 'src/types';
import { WorkflowType } from 'src/types/workflows';

/** Max length for the pathology fax coversheet note. Adjust when CJ confirms final limit. */
export const PATHOLOGY_FAX_NOTE_MAX_LENGTH = 100;

export enum PathologyFaxDialogMode {
  QcApprove = 'qcApprove',
  Refax = 'refax',
}

const REFLEXIVE_ORDERING_PATHWAYS: ReadonlySet<OrderingPathway> = new Set([
  OrderingPathway.StickerTrfReflexive,
  OrderingPathway.OtherFormReflexive,
]);

export const isReflexiveOrderingPathway = (
  pathway: OrderingPathway | null | undefined,
): boolean => pathway != null && REFLEXIVE_ORDERING_PATHWAYS.has(pathway);

/**
 * Default pathology fax action for QC confirmation / retry UI.
 */
export const getDefaultPathologyFaxAction = (
  order: Pick<LdtOrderDetailFieldsFragment, 'orderingPathway' | 'pathologyLab'>,
): PathologyFaxAction => {
  if (isReflexiveOrderingPathway(order.orderingPathway)) {
    return PathologyFaxAction.SkipFaxNoFiles;
  }

  if (order.pathologyLab?.skipFax === true) {
    return PathologyFaxAction.SkipFaxGenerateFiles;
  }

  return PathologyFaxAction.FaxPathologyFiles;
};

/**
 * Checks if the workflow type needs to skip the pathology fax confirmation dialog.
 */
export const shouldSkipPathologyFaxConfirmationDialog = (
  workflowType: WorkflowType,
): boolean => workflowType === WorkflowType.ANCILLARY_LAB;

/** Whether the fax action shows optional pathology report / face sheet selection. */
export const pathologyFaxActionShowsFileSelection = (
  action: PathologyFaxAction,
): boolean => action !== PathologyFaxAction.SkipFaxNoFiles;
